import React, { ReactNode } from "react";
import { useIdentityContext } from "../../context/IdentityContext";
import { LoginPage } from "./LoginPage";
import { PortalWithHeadersLayout } from "../../layouts/PortalWithHeaders/Index";
import { PageAppBar } from "../../layouts/PortalWithHeaders/PageAppBar";
import { useAppSelector } from "../../redux/hooks";
import { getLayout } from "../../redux/Slices/layout.slice";
import { faLoader } from "@fortawesome/pro-light-svg-icons";
import { NoAccessPage } from "../../common/NoAccessPage";
import { SignupPage } from "../Signup/SignupPage";

interface RequireAuthRouteProps {
  roles: string[];
  children: ReactNode;
  useDefaultLayout? : boolean;
};

/*
These checks were in authenticated route:

if (!authenticatedUser.isLoggedIn) {
    
    if (!isEndUser) {
      dispatch(setRedirectRoute(location.pathname + location.search));
      return <Navigate to="/" replace />;
    } 
    
    if (isEndUser) {
      if (location.pathname === '/tickets' || location.pathname === '/settings') {
        dispatch(setRedirectRoute(location.pathname));
        return <Navigate to="/" replace />;
      }
    }
  }

*/

export function RequireAuth({ roles, children, useDefaultLayout = true } : RequireAuthRouteProps) {

  const auth = useIdentityContext();
  const { title, subtitle, icon, links } = useAppSelector(getLayout);
  
  function hasPermission() : boolean
  {
    if (roles.length === 0) return true;
    return auth.authenticatedUser.roles.some((r: string) => roles.indexOf(r) >= 0)
  }

  if (auth.status === "loading") return <div>Loading…</div>;

  if (auth.status === "unauthenticated") {
    return <LoginPage />
  }

  if (auth.status === "unregistered") {
    return <SignupPage />
  }

  return hasPermission() ?   

    useDefaultLayout ? 
      <PortalWithHeadersLayout
        title=""
        paragraph=""
        appBarComponent={
          <PageAppBar
            breadcrumbPageTitle={title}
            mainPageTitle={subtitle}
            mainPageIcon={icon || faLoader}
            links={links || []}
          ></PageAppBar>
        }
      >
        {children}
      </PortalWithHeadersLayout> : 
      <>{children}</>
     : 
    <NoAccessPage />
}

